export const OPEN_LOCAL_360 = 'features/local-360/OPEN_LOCAL_360';
export const CLOSE_LOCAL_360 = 'features/local-360/CLOSE_LOCAL_360';
export function openLocal360(videoId) {
    return {
        type: OPEN_LOCAL_360,
        videoId
    };
}
export function closeLocal360() {
    return {
        type: CLOSE_LOCAL_360
    };
}
export function toggleLocal360(videoId) {
    return (dispatch, getState) => {
        const { isOpen } = getState()['features/local-360'] || {};
        if (isOpen) {
            dispatch(closeLocal360());
        }
        else if (videoId) {
            dispatch(openLocal360(videoId));
        }
    };
}
